/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import BrandCityFacet from './BrandCityFacet';
import BrandCountryFacet from './BrandCountryFacet';
import BrandDistributionInCountriesFacet from './BrandDistributionInCountriesFacet';
import BrandDistributionSoughtCountriesFacet from './BrandDistributionSoughtCountriesFacet';
import {
  cityToggled,
  countryToggled,
  distributionInCountriesToggled,
  distributionSoughtCountriesToggled,
  eventToggled,
  offeringToggled,
  regionToggled,
} from './brandFilterReducer';
import BrandOfferingFacet from './BrandOfferingFacet';
import BrandRegionFacet from './BrandRegionFacet';
import EventsFacet from './EventsFacet';

export default function BrandFilters({
  facets,
  dispatch,
  state,
  totalCount,
  count,
  children,
  ...rest
}) {
  return (
    <Box {...rest}>
      {children}
      <EventsFacet
        allValues={facets.event}
        selectedValues={state.events}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(eventToggled(value), isActive)}
        multiSelect
      />

      <BrandOfferingFacet
        allValues={facets.offerings}
        selectedValues={state.offerings}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(offeringToggled(value), isActive)
        }
      />

      <BrandCountryFacet
        allValues={facets.country}
        selectedValues={state.countries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(countryToggled(value), isActive)
        }
      />
      <BrandRegionFacet
        multiSelect
        allValues={facets.region}
        selectedValues={state.regions}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(regionToggled(value), isActive)}
      />
      <BrandCityFacet
        allValues={facets.city}
        selectedValues={state.cities}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) => dispatch(cityToggled(value), isActive)}
      />

      <BrandDistributionInCountriesFacet
        allValues={facets.distributionInCountries}
        selectedValues={state.distributionInCountries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(distributionInCountriesToggled(value), isActive)
        }
      />

      <BrandDistributionSoughtCountriesFacet
        allValues={facets.distributionSoughtCountries}
        selectedValues={state.distributionSoughtCountries}
        totalCount={totalCount}
        count={count}
        onToggle={(value, isActive) =>
          dispatch(distributionSoughtCountriesToggled(value), isActive)
        }
      />
    </Box>
  );
}

export const fragment = graphql`
  fragment BrandFilters on AbstractBrand {
    marketingActivityTypes
    event {
      name
    }
    country(full: true)
    regions
    city
    distributionInCountries
    distributionSoughtCountries
  }
`;
